module.exports = __webpack_public_path__ + "static/media/loader.0210aeba.gif";